import { V2 } from 'engine/lib/V2';
import { Facet } from './Facet';

export interface StaticSpriteFacetProps {
  frame: React.ReactNode,
  offset?: V2,
  opacity?: number,
}

export class StaticSpriteFacet extends Facet<StaticSpriteFacetProps> {
}
